import DataMappingService from '@/services/DataMappingService';

export function createCSVArrayFromDataResponse(venueWineResponse) {
  const venueWineDataResponse = {
    'data': venueWineResponse
  }
  const venueWines = DataMappingService.mapVenueWineArrayApiToVenueWineArrayUi(venueWineDataResponse)
  return createCSVArrayFromVenueWineList(venueWines)
}
/**
 * Creates a CSV array from an article list
 * The list needs to be in the format of the article list response
 * @param {Array} venueWineList 
 * @returns 
 */
export function createCSVArrayFromVenueWineList(venueWineList) {
  var csvArray = []

  venueWineList.forEach((venueWine) => {

    try {
      var row = {
        Hersteller: venueWine.wine.winery.title,
        Produktname: venueWine.title,
        Jahrgang: venueWine.year,
        Region: venueWine.wine.region.title,
        Land: venueWine.wine.land.title,
        Kategorie: venueWine.wine.category ? venueWine.wine.category?.title ?? '' : '',
        Farbe: venueWine.wine.wineType.title,
        Sorte: venueWine.wine.grapeVariety.title,
        Anzahl: venueWine.amountFloat.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
        EK: venueWine.purchasePriceAvg ? venueWine.purchasePriceAvg.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '',
        VK: venueWine.sellingPrice ? venueWine.sellingPrice.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '',
        Größe: venueWine.bottleSize.amount.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
        Notizen: venueWine.comments,
        Regal: venueWine.shelfNumber
      }
      csvArray.push(row)
    } catch (error) {
      console.error('Error creating CSV row for venueWine with id ' + venueWine.id, error)
    }
	})
  return csvArray
}

export function createCSVArrayFromVenueWineResponse(venueWineDataResponse) {
  var csvArray = []

  const venueWines = DataMappingService.mapVenueWineArrayApiToVenueWineArrayUi(venueWineDataResponse)

  venueWines.forEach((venueWine) => {
    var row = {
      Hersteller: venueWine.wine.winery.title,
      Produktname: venueWine.title,
      Jahrgang: venueWine.year,
      Region: venueWine.wine.region.title,
      Land: venueWine.wine.land.title,
      Kategorie: venueWine.wine.category.title ?? '',
      Farbe: venueWine.wine.wineType.title,
      Sorte: venueWine.wine.grapeVariety.title,
      Anzahl: venueWine.amountFloat,
      EK: venueWine.purchasePriceAvg,
      VK: venueWine.sellingPrice,
      Größe: venueWine.bottleSize.amount,
      Notizen: venueWine.comments,
      Bezugsquelle: venueWine.purchasePrices && venueWine.purchasePrices.length > 0 ? venueWine.purchasePrices[0].wineSupplier.title : 'nicht vorhanden',
      Regal: venueWine.shelfNumber,
      // ID: venueWine.id
    }
    csvArray.push(row)
  })
  return csvArray
}

export function writeArrayToCSVDownload(array, fileName, papaParse) {
  var csv = papaParse.unparse(array);
  var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  var csvURL = null;
  if (navigator.msSaveBlob) {
    csvURL = navigator.msSaveBlob(csvData, fileName + '.csv');
  }
  else {
    csvURL = window.URL.createObjectURL(csvData);
  }

  var tempLink = document.createElement('a');
  tempLink.href = csvURL;
  tempLink.setAttribute('download', fileName + '.csv');
  tempLink.click();
}
